/**
 * Menu script
 */
class FinHub_Menu {
  constructor() {
    this.initState();
    this.initEvents();
  }

  initState() {
    this.win = $(window);
    this.menuWrapper = $('.site-header');
    this.menuIcon = this.menuWrapper.find('.menu-toggle');
    this.menu = this.menuWrapper.find('.menu-wrapper');
    this.menuItemSubmenu = this.menuWrapper.find('.has-submenu');
    this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
  }

  initEvents() {
    this.menuItemSubmenu.append( "<span class='arrow'></span>" );

    $(window).on('scroll', () => {
      let positionY = this.win.scrollTop();

      if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
        this.menuWrapper.addClass('is-fixed');
        return;
      }

      if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
        this.menuWrapper.removeClass('is-fixed');
      }
    });

    if (this.menuIcon.length) {
      this.menuIcon.on('click', e => {
        e.preventDefault();
        this.menu.toggleClass('is-active');
        this.menuIcon.toggleClass('is-active');
        this.menu.find('.menu-item').first().find('.menu-item__link').focus();
        $(document.body).toggleClass('no-scroll');

        setTimeout(() => {
          this.menu.toggleClass('is-showing');
        }, 150);
      });
    }

    if(this.mobileViewport.matches) {
      setTimeout(() => {
        this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
        
        this.menuSubmenuToggle.each(function(i, item) {
          $(item).on('click', (e) => {
            e.stopPropagation();
            $(item).parent().toggleClass('is-active');
          });
        });
      }, 0);
    }
  }
}
